import TourDashboard from './TourDashboard'
export default TourDashboard
